import { useAuth } from '@cibo/profile'
import { WindowLocation } from '@cibo/ui'
import { LAND_MANAGER_ROUTES } from 'navigation/types/routes'
import { Navigate, useLocation } from 'react-router-dom'

export interface OpportunitiesLocationState {
  resourceIds: string[]
}

/**
 *
 * Why a dedicated redirect? b/c I am CERTAIN this behavior will change, just don't know
 * how right now and I want to isolate this functionality.  At the time of writing
 * links into the opportunities route will redirect to either home or field manager
 * based on persona.
 *
 * @returns redirect to a new page
 */
export const OpportunitiesRedirect = () => {
  const { persona } = useAuth()
  const { state } = useLocation() as WindowLocation<OpportunitiesLocationState>

  if (!state.resourceIds) {
    return <Navigate to={LAND_MANAGER_ROUTES.ROOT} state={{}} replace />
  }

  if (persona === 'grower') {
    return <Navigate to="/" state={state} replace />
  }
  return <Navigate to={LAND_MANAGER_ROUTES.ROOT} state={state} replace />
}
